import {
    exitMarket,
    getChartSettings,
    getInitialCurrenciesSettings,
    getTransactionsDetails,
    toggleBinance,
    toggleCreateRenko,
    toggleModel,
    toggleTradeMode,
    updateAMI,
    updateChartDataFormat,
    updateCurrentSide,
    updateSettings,
    updateWalletConfiguration
} from "../../services/rashTradeServices";
import { parisfyData } from "../../utils/common-functions";
import { errorToastify, successToastify } from "../../utils/Toastify";
import {
    CHANGE_APPROACH,
    CHANGE_CURRENCY,
    CHANGE_METHOD,
    CHANGE_SIDE,
    EXIT_MAKET,
    GET_CHARTS_SETTINGS,
    GET_TRANSACTIONS_DETAILS,
    TOGGLE_BINANCE_STATUS,
    TOGGLE_MODEL_STATUS,
    TOGGLE_RENKO_STATUS,
    TOGGLE_SPINNER_STATE,
    TOGGLE_TRANSACTIONS_SPINNER_STATE,
    UPDATE_SETTINGS,
    UPDATE_WALLET_CONFIG,
    USER_BINANCE_ACCOUNT_INFO
} from "./constants";

export const updateAMIAction =
    ({ AMIData, key, valueObject }) =>
    async (dispatch, getState) => {
        const { currenciesList, currentCurrencyId } = parisfyData({
            ...getState().persistedReducer
        });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });

        try {
            await updateAMI({ valueObject });
            currenciesList[currentCurrencyId][key] = AMIData;
            dispatch({ type: CHANGE_APPROACH, payload: currenciesList });
            dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        } catch (error) {
            errorToastify("Approach failed to update!");
            dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        }
    };

export const updateWalletConfigAction = (configData) => async (dispatch, getState) => {
    const { currenciesList, currentCurrencyId, currentSide } = parisfyData({
        ...getState().persistedReducer
    });
    const currentCurrency = currenciesList[currentCurrencyId];
    const currencySideData = currentCurrency[currentSide.side];
    if (currenciesList[currentCurrencyId].symbolInfo) {
        const maxUserVolume = currencySideData["walletConfig"]["maxUserVolume"] || 20;
        const {
            symbolInfo: {
                filters: {
                    [2]: { stepSize, filterType, maxQty, minQty }
                }
            },
            marketPrice
        } = currentCurrency;
        const { leverage, quantity } = configData;
        // if (quantity > maxUserVolume ){
        //     dispatch({ type: UPDATE_WALLET_CONFIG, payload: currenciesList });
        //     errorToastify(`Volum ${quantity} greater than max user volume ${maxUserVolume}!`);
        //     return
        // }
        if (Number(maxQty) < (leverage * quantity) / marketPrice) {
            dispatch({ type: UPDATE_WALLET_CONFIG, payload: currenciesList });
            errorToastify(
                `volume greater than max volume; maxVol with leverage ${leverage}: ${
                    (Number(maxQty) * marketPrice) / leverage
                }  `
            );
            return;
        }
        if (Number(minQty) > (leverage * quantity) / marketPrice) {
            dispatch({ type: UPDATE_WALLET_CONFIG, payload: currenciesList });
            errorToastify(
                `volume less than min volume; minVol with leverage ${leverage}: ${
                    (Number(minQty) * marketPrice) / leverage
                }  `
            );
            return;
        }
    }

    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
    try {
        await updateWalletConfiguration({ side: currentSide.value, walletData: configData });
        currencySideData.walletConfig = {
            ...currencySideData.walletConfig,
            ...configData
        };
        dispatch({ type: UPDATE_WALLET_CONFIG, payload: currenciesList });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        successToastify("Wallet Update successfully.");
    } catch (error) {
        errorToastify(error.response.data.message);
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};
export const updateWalletConfigStreamAction = (configData) => async (dispatch, getState) => {
    const { currenciesList, currentCurrencyId, currentSide } = parisfyData({
        ...getState().persistedReducer
    });
    const currentCurrency = currenciesList[currentCurrencyId];
    const currencySideData = currentCurrency[currentSide.side];
    try {
        currencySideData.walletConfig = {
            ...currencySideData.walletConfig,
            ...configData
        };
        dispatch({ type: UPDATE_WALLET_CONFIG, payload: currenciesList });
    } catch (error) {}
};

export const toggleCreateRenkoAction = (isChartDataFormatRenko) => async (dispatch, getState) => {
    const { currenciesList, currentCurrencyId, currentSide } = {
        ...getState().persistedReducer
    };

    const {
        operations: { isRenkoCreationOn }
    } = currenciesList[currentCurrencyId];
    const currencySideData = currenciesList[currentCurrencyId][currentSide.side];
    const {
        walletConfig: { renkoStartDate },
        currencyConfigs: { renkoPipes }
    } = currencySideData;
    if (!renkoStartDate && !isRenkoCreationOn) {
        return errorToastify("Start Date is not selected!");
    }
    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });

    try {
        const { data } = await toggleCreateRenko({
            isRenkoCreationOn,
            walletConfig: { renkoPipes, renkoStartDate },
            isChartDataFormatRenko
        });
        currenciesList[currentCurrencyId] = {
            ...currenciesList[currentCurrencyId],
            operations: {
                ...currenciesList[currentCurrencyId].operations,
                isRenkoCreationOn: !isRenkoCreationOn
            }
        };
        dispatch({ type: TOGGLE_RENKO_STATUS, payload: currenciesList });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        successToastify(data.message);
    } catch (error) {
        errorToastify(error?.response?.data?.message || error);
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};

export const toggleModelAction = () => async (dispatch, getState) => {
    const { currenciesList, currentCurrencyId, currentSide } = {
        ...getState().persistedReducer
    };
    const {
        approach: { approachId },
        interestType: { interestId },
        tradeMethod,
        operations: { isRenkoCreationOn, isModelOn }
    } = currenciesList[currentCurrencyId];
    const {
        walletConfig: { stopLoss, takeProfit },
        walletConfig,
        currencyConfigs: { renkoPipes, timeFrame, strategyType }
    } = currenciesList[currentCurrencyId][currentSide.side];
    if (!isRenkoCreationOn && !isModelOn) {
        return errorToastify("Renko creation must run first!");
    }
    if (stopLoss >= 0) {
        return errorToastify("Stoploss cannot be more than 0!");
    }
    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });

    try {
        let configData = {
            ...walletConfig,
            renkoPipes,
            timeFrame,
            strategyType
        };
        const { data } = await toggleModel({
            isModelOn,
            approachId,
            interestId,
            methodId: tradeMethod.methodId,
            walletConfig: configData
        });
        currenciesList[currentCurrencyId] = {
            ...currenciesList[currentCurrencyId],
            operations: {
                ...currenciesList[currentCurrencyId].operations,
                isModelOn: !isModelOn
            },
            realTimeStatus: {
                candleClosePrice: "",
                entrySide: ""
            },
            totalStatus: {
                ...currenciesList[currentCurrencyId].totalStatus,
                activePosition: "",
                lastPositionProfit: null,
                accumulativeProfit: null,
                isPositionOpen: false,
                indexZero: "",
                indexOne: ""
            },
            [currentSide.side]: {
                ...currenciesList[currentCurrencyId][currentSide.side],
                walletConfig: {
                    ...currenciesList[currentCurrencyId][currentSide.side].walletConfig,
                    renkoSkips: isModelOn
                        ? 0
                        : currenciesList[currentCurrencyId][currentSide.side].walletConfig
                              .renkoSkips
                }
            }
        };
        dispatch({ type: TOGGLE_MODEL_STATUS, payload: currenciesList });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        successToastify(data.message);
    } catch (error) {
        errorToastify(error.response.data.message);
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};
export const toggleBinanceAction = () => async (dispatch, getState) => {
    const { currenciesList, currentCurrencyId, currentSide } = parisfyData({
        ...getState().persistedReducer
    });
    const {
        operations: { isBinanceOn, isTradeOn, isModelOn },
        approach: { approachId },
        tradeMethod: methodId
    } = currenciesList[currentCurrencyId];
    if (!isModelOn) {
        return errorToastify("Model program is not on!");
    }
    const {
        walletConfig: { stopLoss, takeProfit },
        walletConfig,
        currencyConfigs: { renkoPipes, timeFrame, strategyType }
    } = currenciesList[currentCurrencyId][currentSide.side];

    if (stopLoss >= 0) {
        return errorToastify("Stoploss cannot be more than 0!");
    }
    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
    let configData = {
        ...walletConfig,
        renkoPipes,
        timeFrame,
        strategyType
    };
    try {
        const { data } = await toggleBinance({
            isBinanceOn,
            approachId,
            configData,
            methodId,
            binanceMode: isTradeOn
        });

        currenciesList[currentCurrencyId] = {
            ...currenciesList[currentCurrencyId],
            realTimeStatus: {
                candleClosePrice: "",
                entrySide: ""
            },
            totalStatus: {
                ...currenciesList[currentCurrencyId].totalStatus,
                activePosition: "",
                lastPositionProfit: null,
                accumulativeProfit: null,
                isPositionOpen: false,
                indexZero: "",
                indexOne: ""
            },
            operations: {
                ...currenciesList[currentCurrencyId].operations,
                isBinanceOn: !isBinanceOn,
                isTradeOn: false
            }
        };
        dispatch({ type: TOGGLE_BINANCE_STATUS, payload: currenciesList });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        successToastify(data.message);
    } catch (error) {
        errorToastify(error.response.data.message);
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};

export const toggleTradeModeAction = () => async (dispatch, getState) => {
    const { currenciesList, currentCurrencyId } = {
        ...getState().persistedReducer
    };

    const {
        operations: { isBinanceOn, isTradeOn },
        approach: { approachId },
        tradeMethod: methodId
    } = currenciesList[currentCurrencyId];
    if (!isBinanceOn) {
        return errorToastify("Binance program is not on!");
    }
    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
    try {
        const { data } = await toggleTradeMode({
            isBinanceOn,
            approachId,
            binanceMode: isTradeOn,
            methodId
        });
        currenciesList[currentCurrencyId] = {
            ...currenciesList[currentCurrencyId],
            realTimeStatus: {
                candleClosePrice: "",
                entrySide: ""
            },
            totalStatus: {
                ...currenciesList[currentCurrencyId].totalStatus,
                activePosition: "",
                lastPositionProfit: null,
                accumulativeProfit: null,
                isPositionOpen: false,
                indexZero: "",
                indexOne: ""
            },

            operations: {
                ...currenciesList[currentCurrencyId].operations,
                isTradeOn: !isTradeOn
            }
        };
        dispatch({ type: TOGGLE_BINANCE_STATUS, payload: currenciesList });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        successToastify(data.message);
    } catch (error) {
        errorToastify(error?.response?.data?.message || error);
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};

export const getChartSettingsAction = () => async (dispatch, getState) => {
    const { currenciesList, currentCurrencyId } = {
        ...getState().persistedReducer
    };
    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
    try {
        const {
            data: { currencySettings, currenciesStatus, symbolInfo, currentSide }
        } = await getChartSettings();
        currenciesList[currentCurrencyId] = {
            ...currenciesList[currentCurrencyId],
            ...currencySettings
        };
        currenciesStatus.length !== 0 &&
            currenciesStatus.forEach((currency) => {
                const {
                    currency_id,
                    trade_status,
                    entry_price,
                    entry_side,
                    renko_status,
                    model_status,
                    binance_status
                } = currency;
                if (!currenciesList[currency_id]) {
                    return currenciesList;
                }
                return (currenciesList[currency_id] = {
                    ...currenciesList[currency_id],
                    realTimeStatus: {
                        candleClosePrice: entry_price,
                        entrySide: entry_side
                    },
                    operations: {
                        ...currenciesList[currency_id].operations,
                        isRenkoCreationOn: renko_status === 1 ? true : false,
                        isModelOn: model_status === 1 ? true : false,
                        isBinanceOn: binance_status === 1 ? true : false,
                        isTradeOn: trade_status === 1 ? true : false
                    },
                    symbolInfo
                });
            });
        dispatch({ type: CHANGE_SIDE, payload: currentSide });
        dispatch({ type: GET_CHARTS_SETTINGS, payload: currenciesList });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    } catch (error) {
        errorToastify(error);
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};
export const getInitialCurrenciesSettingsAction = () => async (dispatch, getState) => {
    const { currenciesList } = {
        ...getState().persistedReducer
    };
    try {
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
        const {
            data: { currenciesSettings }
        } = await getInitialCurrenciesSettings();
        for (const currencySetting of currenciesSettings) {
            const { currencyId, currencySettings, symbolInfo, configs } = currencySetting;
            const {
                trade_status,
                entry_price,
                entry_side,
                renko_status,
                model_status,
                binance_status
            } = configs;
            currenciesList[currencyId] = {
                ...currenciesList[currencyId],
                ...currencySettings
            };
            currenciesList[currencyId] = {
                ...currenciesList[currencyId],
                realTimeStatus: {
                    candleClosePrice: entry_price,
                    entrySide: entry_side
                },
                operations: {
                    ...currenciesList[currencyId].operations,
                    isRenkoCreationOn: renko_status === 1 ? true : false,
                    isModelOn: model_status === 1 ? true : false,
                    isBinanceOn: binance_status === 1 ? true : false,
                    isTradeOn: trade_status === 1 ? true : false
                },
                symbolInfo
            };
        }
        dispatch({ type: GET_CHARTS_SETTINGS, payload: currenciesList });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    } catch (error) {
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        errorToastify(error);
    }
};

export const updateSettingsAction = (updatedData) => async (dispatch, getState) => {
    const { currenciesList, currentCurrencyId, currentSide } = parisfyData({
        ...getState().persistedReducer
    });
    let updatedValues = Object.values(updatedData);
    for (let input of updatedValues) {
        if (!input.value) {
            errorToastify(`${input.placeholder} cannot be empty!`);
            return;
        }
    }
    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
    try {
        const {
            data: { message }
        } = await updateSettings({
            side: currentSide.value,
            updatedData
        });
        const {
            strategy,
            renkoSize,
            timeFrame,
            upperBRP,
            lowerBRP,
            // renkoNumber,
            // slingShotFastCandle,
            // slingShotSlowCandle,
            slingShotFastRenko,
            slingShotSlowRenko,
            movingaverage1,
            movingaverage2,
            movingaverage3,
            movingaverage4,
            movingaverage5,
            manRateDown,
            manRateUp,
            sideWaveLevelBuy,
            sideWaveLevelSell
        } = updatedData;

        currenciesList[currentCurrencyId] = {
            ...currenciesList[currentCurrencyId],
            waveLevels: {
                buyWave: sideWaveLevelBuy.value,
                sellWave: sideWaveLevelSell.value
            },
            [currentSide.side]: {
                ...currenciesList[currentCurrencyId][currentSide.side],
                currencyConfigs: {
                    ...currenciesList[currentCurrencyId][currentSide.side].currencyConfigs,
                    renkoPipes: renkoSize.value,
                    timeFrame: timeFrame.value,
                    strategyType: strategy.value,
                    emaValueFastRenko: slingShotFastRenko.value,
                    emaValueSlowRenko: slingShotSlowRenko.value,
                    mastep1: movingaverage1.value,
                    mastep2: movingaverage2.value,
                    mastep3: movingaverage3.value,
                    mastep4: movingaverage4.value,
                    mastep5: movingaverage5.value,
                    waveEma1: manRateDown.value,
                    waveEma2: manRateUp.value,
                    upperBoundRangePercentage: upperBRP.value,
                    lowerBoundRangePercentage: lowerBRP.value
                }
            }
        };
        dispatch({ type: UPDATE_SETTINGS, payload: currenciesList });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        successToastify(message);
    } catch (error) {
        errorToastify(error);
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};
export const updateChartDataFormatAction =
    (isChartDataFormatRenko) => async (dispatch, getState) => {
        const { currenciesList, currentCurrencyId, currentSide } = parisfyData({
            ...getState().persistedReducer
        });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
        try {
            const {
                data: { message }
            } = await updateChartDataFormat({
                isChartDataFormatRenko
            });
            currenciesList[currentCurrencyId] = {
                ...currenciesList[currentCurrencyId],
                isChartDataFormatRenko
            };
            dispatch({ type: UPDATE_SETTINGS, payload: currenciesList });
            dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        } catch (error) {
            errorToastify(error);
            dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        }
    };
export const getTransactionsDetailsAction =
    ({ page, sort, type }) =>
    async (dispatch, getState) => {
        const { currenciesList, currentCurrencyId, currentSide } = parisfyData({
            ...getState().persistedReducer
        });
        dispatch({ type: TOGGLE_TRANSACTIONS_SPINNER_STATE, payload: true });
        try {
            const {
                data: { data, rowsLength }
            } = await getTransactionsDetails({
                side: currentSide.side,
                page,
                sort,
                type: type.categ
            });
            currenciesList[currentCurrencyId][type.obj] = {
                data,
                rowsLength
            };
            dispatch({
                type: GET_TRANSACTIONS_DETAILS,
                payload: currenciesList
            });
            dispatch({
                type: TOGGLE_TRANSACTIONS_SPINNER_STATE,
                payload: false
            });

            // GET_TRANSACTIONS_DETAILS
        } catch (error) {
            errorToastify(error.response.data.message);
            dispatch({
                type: TOGGLE_TRANSACTIONS_SPINNER_STATE,
                payload: false
            });
        }
    };

export const exitMarketAction =
    ({ currentCurrencyId, entrySide, storeInDb, binanceMode }) =>
    async (dispatch, getState) => {
        const { currenciesList, currentSide, userInfo } = parisfyData({
            ...getState().persistedReducer
        });
        const {
            walletConfig: { quantity, marginType, leverage },
            currencyConfigs: { strategyType }
        } = currenciesList[currentCurrencyId][entrySide];
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });

        try {
            const {
                data: { message }
            } = await exitMarket({
                currencyId: currentCurrencyId,
                side: entrySide,
                qty: quantity,
                margin: marginType,
                leverage,
                strategyType,
                storeInDb,
                binanceMode
            });
            currenciesList[currentCurrencyId] = {
                ...currenciesList[currentCurrencyId],
                operations: {
                    ...currenciesList[currentCurrencyId].operations,
                    isModelOn: false,
                    isBinanceOn: false,
                    isTradeOn: false
                },
                realTimeStatus: {
                    candleClosePrice: "",
                    entrySide: ""
                },
                totalStatus: {
                    ...currenciesList[currentCurrencyId].totalStatus,
                    activePosition: "",
                    lastPositionProfit: null,
                    accumulativeProfit: null,
                    isPositionOpen: false,
                    indexZero: "",
                    indexOne: ""
                }
            };

            const newOpenPositionsList = userInfo.openPositionsList?.filter(
                (pos) => pos.symbol?.split("USDT")[0] !== currentCurrencyId
            );
            userInfo.openPositionsList = newOpenPositionsList;
            dispatch({ type: USER_BINANCE_ACCOUNT_INFO, payload: userInfo });
            dispatch({
                type: EXIT_MAKET,
                payload: currenciesList
            });
            dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
            successToastify(message);
        } catch (error) {
            errorToastify(error.response.data.message);
            dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
        }
    };

export const changeCurrency = (currencyId) => {
    return {
        type: CHANGE_CURRENCY,
        payload: currencyId
    };
};

export const changeSide = (currentSide) => async (dispatch, getState) => {
    dispatch({ type: TOGGLE_SPINNER_STATE, payload: true });
    try {
        await updateCurrentSide(currentSide);
        dispatch({ type: CHANGE_SIDE, payload: currentSide });
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    } catch (error) {
        errorToastify(error.response.data.message);
        dispatch({ type: TOGGLE_SPINNER_STATE, payload: false });
    }
};
